import { createAction, createSlice } from '@reduxjs/toolkit';

import { resetStateAction, userInstrumentsSlice } from '!core/redux';
import { setFavInstr } from '»utils/setFavInstr';

const initialState = {
  data: [],
  extra: {},
  selectedTitle: {},
  currentTab: 0,
};

const logoutSuccessAction = createAction('logoutSlice/logoutSuccess');

const clearState = () => ({ ...initialState });

export const marketStockExchangeSlice = createSlice({
  name: 'marketStockExchangeSlice',
  initialState,
  reducers: {
    marketStockExchangeRequest: (state, action) => {
      const { webAreaId } = action.payload;

      state.isLoading = true;
      state.tabWebAreaId = webAreaId;
    },
    marketStockExchangeSucess: (state, action) => {
      state.selectedTitle = { ...action.payload[0] };
      state.data = action.payload;
      state.isLoading = false;
    },
    marketStockExchangeFailure: (state) => {
      state.isLoading = false;
    },
    webAreasRequest: (state) => {
      state.isLoading = true;
    },
    webAreasSuccess: (state, action) => {
      const visibleWebAreas = action.payload.filter(
        (webArea) => webArea.alwaysVisible === 'Y' || webArea.isVisible === 'Y',
      );

      state.webAreas = visibleWebAreas;
      state.isLoading = false;
    },
    webAreasFailure: (state) => {
      state.isLoading = false;
    },
    webAreaGraphQuotesRequest: (state) => state,
    webAreaGraphQuotesSucess: (state, action) => {
      const { stockExchangeData } = action.payload;

      const updatedSelectedTitle = {
        ...state.selectedTitle,
        chartData: stockExchangeData.find(
          (title) =>
            title.securityType === state.selectedTitle.securityType &&
            title.symbol === state.selectedTitle.symbol &&
            title.exchange === state.selectedTitle.exchange,
        ),
      };

      const updatedState = {
        ...state,
        data: stockExchangeData,
        selectedTitle: updatedSelectedTitle,
      };

      return updatedState;
    },
    webAreaGraphQuotesFailure: (state) => state,
    setSelectedTitle: (state, action) => {
      let title = {};

      if (Object.keys(action.payload).length > 0) {
        const { symbol, exchange, securityType } = action.payload;

        title = state.data.find(
          (element) =>
            element.symbol === symbol &&
            element.exchange === exchange &&
            element.securityType === securityType,
        );
      }

      state.selectedTitle = title;
    },
    resetMarketStockExchange: (state) => {
      state.data = [];
    },
    marketStockExchangeInstrumentRequest: (state) => {
      state.isLoading = true;
    },
    marketStockExchangeInstrumentSucess: (state, action) => {
      const updatedState = state.data.map((item) => {
        if (
          item.exchange === action.payload.exchange &&
          item.symbol === action.payload.symbol &&
          item.securityType === action.payload.securityType
        ) {
          return { ...item, ...action.payload };
        }

        return item;
      });

      state.selectedTitle = { ...state.selectedTitle, ...action.payload };
      state.data = updatedState;
      state.isLoading = false;
    },
    marketStockExchangeInstrumentFailure: (state) => {
      state.isLoading = false;
    },
    setCurrentTab: (state, action) => {
      state.currentTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logoutSuccessAction, clearState)
      .addCase(resetStateAction, clearState)
      .addCase(
        userInstrumentsSlice.actions.setFavInstrumentSuccess,
        (state, action) => {
          const { option, instrument, symbol, exchange, securityType } =
            action.payload;

          const { updatedTitle, updatedData } = setFavInstr({
            option,
            instrument,
            symbol,
            exchange,
            securityType,
            data: state.data,
            updateSelectedTitle: true,
          });

          if (Object.keys(updatedTitle).length > 0) {
            state.selectedTitle = updatedTitle;
          }

          state.data = updatedData;
        },
      );
  },
});
